{
	"showLess": "Mostrar menos",
	"showMore": "Mostrar más ({{remainingElements}})"
}
